<template>
    <div class="main_container app dashboard">
        <section>
            <h1>{{ translations.dashboard.title }}</h1>
            <h3 class="subtitle">{{ translations.dashboard.subtitle }}</h3>
            <span class="line gray"></span>
        </section>
        <comp_dashboard></comp_dashboard>
        <comp_modal_overlay></comp_modal_overlay>
    </div>
</template>

<script>
import App from './../application'
import comp_dashboard from "./comp_dashboard.vue"
import comp_modal_overlay from "./comp_modal_overlay.vue"

export default {

    components: {
        comp_dashboard,
        comp_modal_overlay
    },
    data: function () {
        return {
            translations: {
                dashboard: App.current_translations['dashboard'],
                generic: App.current_translations['generic']
            }
        }
    }
}
</script>

<style>
</style>